export default __webpack_public_path__ + "static/media/5.c2731b1b.jpg";